var _ellipse, _ellipse2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondShineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "discount-second-shine",
    width: 76,
    height: 18,
    viewBox: "0 0 76 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter0_f_1932_14498)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 9,
    rx: 33,
    ry: 4,
    fill: "url(#paint0_radial_1932_14498)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter1_f_1932_14498)"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.5,
    cy: 8,
    rx: 19.5,
    ry: 2,
    fill: "url(#paint1_radial_1932_14498)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1932_14498",
    x: 0.0999999,
    y: 0.0999999,
    width: 75.8,
    height: 17.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.45,
    result: "effect1_foregroundBlur_1932_14498"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1932_14498",
    x: 13.1,
    y: 1.1,
    width: 48.8,
    height: 13.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.45,
    result: "effect1_foregroundBlur_1932_14498"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1932_14498",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38 9) scale(33 4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339522,
    stopColor: "#8756E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#301D8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1932_14498",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5 8) scale(19.5 2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339522,
    stopColor: "#8756E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#301D8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondShineIcon);
export default __webpack_public_path__ + "static/media/SecondShineIcon.2049e39d0c216eb861d7ec9f4fb00981.svg";
export { ForwardRef as ReactComponent };